import React from 'react';

import { CreateAuthorizedForm, Header } from 'components';
import { PrivateRoute } from 'utils';

export const CreateAuthorizedPdf = () => {
  PrivateRoute();

  return (
    <>
      <Header />
      <CreateAuthorizedForm />
    </>
  );
};
